import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import withAuthorization from "../../components/Authorization/withAuthorization";
import NoDataFound from "../Errors/NoDataFound";
import Loading from "../../components/Loading/Loading";
import _ from "lodash";
import GroupProfile from "./GroupProfile";
import GroupDetailsButton from "./GroupDetailsButton";
import LockDetailsButton from "./GroupLocksButton";
import { getMergedGroupLocks } from "./GroupLocksHelper";
import { style } from "variables/Variables.jsx";
import { confirmAlert } from "react-confirm-alert";
import NotificationSystem from "react-notification-system";
import { Modal, ControlLabel, FormControl, Button } from "react-bootstrap";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
  SizePerPageDropDown,
  ExportCSVButton,
} from "react-bootstrap-table";
import TimeStamp from "react-timestamp";
import Multiselect from "react-widgets/lib/Multiselect";
import CreateGroupGuide from "../Tutorial/CreateGroupGuide";
import { ExportToCsv } from "export-to-csv";
import * as XLSX from "xlsx";
// Css
import "../../assets/css/groupmanagement.css";

import LocalizedStrings from "react-localization";
import { customLog, timestampToDate } from "../../variables/Variables";
import { FormGroup } from "semantic-ui-react";

let localizationStrings = new LocalizedStrings({
  en: {
    descriptionTitle: "Create and edit your group here",
    createGroupBtn: "Create Group",
    deleteGroupBtn: "Delete Group",
    groupNameHeader: "Group Name",
    groupLocksHeader: "Group Locks",
    createdAtHeader: "Created At",
    groupInfoHeader: "Info",
    groupEditHeader: "Edit",
    resultTitle1: "Showing ",
    resultTitle2: " to ",
    resultTitle3: " of ",
    resultTitle4: " Results",
    groupNamePlaceholder: "Enter Group Name",
    groupDescriptionHeader: "Group Description (optional)",
    groupDescriptionPlaceholder: "Enter Group Description",
    recurringNonSharedLockTitle: "Recurring Non-Shared Lock",
    nonSharedLockTitle: "Non-Shared Lock",
    multiApproveAccess: "Multi Approve Access",
    multiApproveOneTimeAccess: "Multi Approve & One Time Access",
    oneTimeAccess: "One Time Access",
    exportCSVTitle: "Export CSV",
    exportMemberTitle: "MEMBERS: ",
    // addMembersHeader: "Add Members",
    addMembersHeader: "Select Members",
    removeMemberBtn: "Remove Member",
    nameHeader: "Name",
    emailHeader: "Email",
    // selectedMembersHeader: "Selected Members",
    selectedMembersHeader: "Group Member List",
    confirmRemoveTitle: "Confirm Remove",
    removeGroupTitle: "Remove group?",
    confirmTitle: "Confirm",
    cancelTitle: "Cancel",
    createTitle: "Create",
    noDataTitle: "There is no data to display",
    createGroupGuide: "Group Management",
    locknameHeader: "Lock Name",
    lockSerialHeader: "Lock Serial",
    shareModeHeader: "Share Mode",
    startHeader: "Start",
    endHeader: "End",
    exportGroupsHeader: "Export Groups",
    exportBtn: "Export",
    cancelBtn: "Cancel",
    searchPlaceholder: "Search",
    successfulGrpDelNotif: "Groups successfully deleted",
    // selectGrpNotif: "Please select at least one group to export",
    selectMemberEnterNameNotif:
      "Please enter a group name and select at least 2 group members",
    enterNameNotif: "Please enter a group name",
    selectMemberNotif:
      "Please ensure that you have selected at least 2 members to be added into the group",
    createGrpUnsuccessfulNotif: "Unable to create group, Please try again",
    grpNameExistNotif: "Group name already exists",
    grpCreatedNotif: "Group successfully created",
    loading: "Loading...",
  },
  ja: {
    descriptionTitle: "グループ編集",
    createGroupBtn: "グルーピング",
    deleteGroupBtn: "グループ削除",
    groupNameHeader: "グループ名",
    groupLocksHeader: "登録スマートロック",
    createdAtHeader: "登録",
    groupInfoHeader: "お知らせ",
    groupEditHeader: "編集",
    resultTitle1: "表示 ",
    resultTitle2: " へ",
    resultTitle3: " の ",
    resultTitle4: " 結果",
    groupNamePlaceholder: "グループ名入力",
    groupDescriptionHeader: "グループメモ（オプション）",
    groupDescriptionPlaceholder: "グループメモ入力",
    nonSharedLockTitle: "共有していません",
    recurringNonSharedLockTitle: "曜日設定",
    multiApproveAccess: "承認者追加",
    multiApproveOneTimeAccess: "承認者追加＆ワンタイム解錠",
    oneTimeAccess: "ワンタイム解錠",
    exportCSVTitle: "CSV出力",
    exportMemberTitle: "メンバー: ",
    // addMembersHeader: "Add Members",
    addMembersHeader: "メンバー選択",
    removeMemberBtn: "メンバーを削除",
    nameHeader: "名前",
    emailHeader: "Eメール",
    // selectedMembersHeader: "Selected Members",
    selectedMembersHeader: "グループメンバーリスト",
    confirmRemoveTitle: "登録削除",
    removeGroupTitle: "グループを削除しますか？",
    confirmTitle: "OK",
    cancelTitle: "キャンセル",
    createTitle: "登録",
    noDataTitle: "表示するデータがありません。",
    createGroupGuide: "グループ管理",
    locknameHeader: "ロック名",
    lockSerialHeader: "ロックシリアル",
    shareModeHeader: "共有モード",
    startHeader: "アクセス開始日",
    endHeader: "アクセス終了日",
    exportGroupsHeader: "グループのエクスポート",
    exportBtn: "エクスポート",
    cancelBtn: "キャンセル",
    searchPlaceholder: "検索",
    successfulGrpDelNotif: "グループは正常に削除されました",
    // selectGrpNotif: "エクスポートするグループを少なくとも1つ選択してください",
    selectMemberEnterNameNotif:
      "グループ名を入力し、少なくとも2人のグループメンバーを選択してください",
    enterNameNotif: "グループ名を入力してください",
    selectMemberNotif:
      "グループに追加するメンバーを少なくとも2人選択していることを確認してください",
    createGrpUnsuccessfulNotif:
      "グループの作成に失敗しました。もう一度お試しください",
    grpNameExistNotif: "グループ名はすでに存在します",
    grpCreatedNotif: "グループの作成に成功しました",
    loading: "読み込み中...",
  },
  es: {
    descriptionTitle: "Crea y edita tu grupo aquí",
    createGroupBtn: "Crear Grupo",
    deleteGroupBtn: "Eliminar Grupo",
    groupNameHeader: "Nombre del Grupo",
    groupLocksHeader: "Candados del Grupo",
    createdAtHeader: "Creado En",
    groupInfoHeader: "Información",
    groupEditHeader: "Editar",
    resultTitle1: "Mostrando ",
    resultTitle2: " a ",
    resultTitle3: " de ",
    resultTitle4: " Resultados",
    groupNamePlaceholder: "Introduce el Nombre del Grupo",
    groupDescriptionHeader: "Descripción del Grupo (opcional)",
    groupDescriptionPlaceholder: "Introduce la Descripción del Grupo",
    recurringNonSharedLockTitle: "Candado No Compartida Recurrente",
    nonSharedLockTitle: "Candado No Compartida",
    multiApproveAccess: "Acceso con Aprobación Múltiple",
    multiApproveOneTimeAccess: "Aprobación Múltiple y Acceso Único",
    oneTimeAccess: "Acceso Único",
    exportCSVTitle: "Exportar CSV",
    exportMemberTitle: "MIEMBROS: ",
    addMembersHeader: "Seleccionar Miembros",
    removeMemberBtn: "Eliminar Miembro",
    nameHeader: "Nombre",
    emailHeader: "Correo Electrónico",
    selectedMembersHeader: "Lista de Miembros del Grupo",
    confirmRemoveTitle: "Confirmar Eliminación",
    removeGroupTitle: "¿Eliminar grupo?",
    confirmTitle: "Confirmar",
    cancelTitle: "Cancelar",
    createTitle: "Crear",
    noDataTitle: "No hay datos para mostrar",
    createGroupGuide: "Gestión de Grupos",
    locknameHeader: "Nombre de la Candado",
    lockSerialHeader: "Número de Serie de la Candado",
    shareModeHeader: "Modo de Compartir",
    startHeader: "Inicio",
    endHeader: "Fin",
    exportGroupsHeader: "Exportar Grupos",
    exportBtn: "Exportar",
    cancelBtn: "Cancelar",
    searchPlaceholder: "Buscar",
    successfulGrpDelNotif: "Grupos eliminados correctamente",
    // selectGrpNotif: "Por favor, selecciona al menos un grupo para exportar",
    selectMemberEnterNameNotif:
      "Por favor, ingresa un nombre de grupo y selecciona al menos 2 miembros del grupo",
    enterNameNotif: "Por favor, ingresa un nombre de grupo",
    selectMemberNotif:
      "Por favor, asegúrate de haber seleccionado al menos 2 miembros para agregar al grupo",
    createGrpUnsuccessfulNotif:
      "No se pudo crear el grupo. Por favor, inténtalo de nuevo",
    grpNameExistNotif: "El nombre del grupo ya existe",
    grpCreatedNotif: "Grupo creado con éxito",
    loading: "Cargando...",
  },
});

const buildGroupDeleteMessage = (rowKeys = [], groups = []) => {
  const selectedGroupIds = new Set(rowKeys);
  const lines = [];
  let count = 0;

  for (let i = 0; i < groups.length; i++) {
    const group = groups[i];

    if (selectedGroupIds.has(group.groupID)) {
      const groupName = group.groupName || "-";
      const memberCount = group.groupMembers
        ? Object.keys(group.groupMembers).length
        : 0;
      const createdAt = group.timeCreated
        ? new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(group.timeCreated)
        : "-";

      lines.push(
        `${count + 1}. ${groupName} — ${memberCount} member${
          memberCount !== 1 ? "s" : ""
        }`,
      );

      count += 1;
      if (count === 5) break;
    }
  }

  const total = rowKeys.length;

  return (
    <div>
      <div>
        You are about to remove <strong>{total}</strong> selected group
        {total > 1 ? "s" : ""}.
      </div>

      <div style={{ marginTop: "10px", marginBottom: "10px" }}>
        {lines.map((line, index) => (
          <div key={index}>{line}</div>
        ))}

        {total > 5 && (
          <div style={{ marginTop: "8px", fontStyle: "italic" }}>
            ...and {total - 5} more.
          </div>
        )}
      </div>

      <div>{localizationStrings.removeGroupTitle}</div>
    </div>
  );
};

const confirmRemove = (next, rowKeys, groups = []) => {
  confirmAlert({
    title: `${localizationStrings.confirmRemoveTitle} (${rowKeys.length})`,
    message: buildGroupDeleteMessage(rowKeys, groups),
    buttons: [
      {
        label: localizationStrings.confirmTitle,
        onClick: () => next(),
      },
      {
        label: localizationStrings.cancelTitle,
        onClick: () => false,
      },
    ],
  });
};

class GroupManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _notificationSystem: null,
      showPopup: false,
      showExportPopup: false,
      groupName: "",
      groupNameExist: false,
      groupDesc: "",
      memberemaillistArray: [],
      selectedMember: [],
      selectedMemberValue: [],
      groupsArrayList: [],
      selectedGroups: [],
      isSuperAdmin: false,
      isAdmin: false,
      superAdminID: "",
      loading: true,
      showPopupHelp: false,
      popupTitle: "",
      popupImage: [],
      selectedGroupRows: [],
      addGroupLoading: false,
      isExportingCSV: false,
    };

    this.createCustomInsertButton = this.createCustomInsertButton.bind(this);
    this.createCustomDeleteButton = this.createCustomDeleteButton.bind(this);
    this.onAfterDeleteRow = this.onAfterDeleteRow.bind(this);
    this.createCustomSearchField = this.createCustomSearchField.bind(this);
    this.createCustomSearchFieldForm = this.createCustomSearchFieldForm.bind(
      this,
    );
    this.retrieveGroupDetails = this.retrieveGroupDetails.bind(this);
    this.handleCreateGroupPopupOpen = this.handleCreateGroupPopupOpen.bind(
      this,
    );
    this.handleCreateGroupPopupClose = this.handleCreateGroupPopupClose.bind(
      this,
    );
    this.onSubmit = this.onSubmit.bind(this);
    this.insertGroupData = this.insertGroupData.bind(this);
    this.handleGroupNameChange = this.handleGroupNameChange.bind(this);
    this.handleGroupDescChange = this.handleGroupDescChange.bind(this);
    this.handleSelectedMembers = this.handleSelectedMembers.bind(this);
    this.createGroupCustomDeleteButton = this.createGroupCustomDeleteButton.bind(
      this,
    );
    this.customConfirmDialog = this.customConfirmDialog.bind(this);
    this.createGroupOnAfterDeleteRow = this.createGroupOnAfterDeleteRow.bind(
      this,
    );
    this.convertTimeStamp = this.convertTimeStamp.bind(this);
    this.renderGroupProfile = this.renderGroupProfile.bind(this);
    this.renderLockDetailsBtn = this.renderLockDetailsBtn.bind(this);
    this.renderGroupDetailsBtn = this.renderGroupDetailsBtn.bind(this);
    this.onToggleDropDown = this.onToggleDropDown.bind(this);
    this.renderSizePerPageDropDown = this.renderSizePerPageDropDown.bind(this);
    this.renderSelectMember = this.renderSelectMember.bind(this);
    this.unselectMember = this.unselectMember.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handleExportCSV = this.handleExportCSV.bind(this);
    this.convertStartTime = this.convertStartTime.bind(this);
    this.convertEndTime = this.convertEndTime.bind(this);
  }

  async componentDidMount() {
    const user = auth.currentUser;

    this.setState({
      _notificationSystem: this.refs.notificationSystem,
    });

    if (!user) {
      this.setState({ loading: false });
      return;
    }

    try {
      //! LANGUAGE SETTING
      this.languageRef = fire
        .database()
        .ref("userSettings")
        .child(user.uid)
        .child("language");

      this.languageRef.on("value", (snapshot) => {
        this.setState({
          currentLanguage: snapshot.val(),
        });
      });

      //! LOAD ALL DATA IN PARALLEL
      const [groupAccountsSnap, friendListSnap, usersSnap] = await Promise.all([
        fire
          .database()
          .ref("groupAccounts")
          .once("value"),
        fire
          .database()
          .ref("userFriendListIndustrial")
          .child(user.uid)
          .orderByKey()
          .once("value"),
        fire
          .database()
          .ref("registeredUsersOnPlatform")
          .once("value"),
      ]);

      let isAdmin = false;
      let isSuperAdmin = false;
      let superAdminID = "";
      let groupsArrayList = [];

      //! FIND CURRENT USER MEMBERSHIP
      if (groupAccountsSnap.exists()) {
        let foundUser = false;

        groupAccountsSnap.forEach((superAdmin) => {
          if (foundUser) return true;

          const superAdminData = superAdmin.val() || {};
          const memberDetails = superAdminData.members || {};

          for (let eachMemberId in memberDetails) {
            const eachMemberDetails = memberDetails[eachMemberId];
            const eachMemberEmail = eachMemberDetails.memberEmail;

            if (eachMemberEmail === user.email) {
              isAdmin = !!eachMemberDetails.isAdmin;
              isSuperAdmin = !!eachMemberDetails.isSuperAdmin;
              superAdminID = superAdmin.key;
              foundUser = true;
              return true;
            }
          }

          return false;
        });
      }

      //! LOAD GROUP LIST
      if (superAdminID) {
        const groupManagementSnap = await fire
          .database()
          .ref("GroupManagement")
          .child(superAdminID)
          .child(user.uid)
          .once("value");

        const tempGroups = [];
        groupManagementSnap.forEach((childSnap) => {
          tempGroups.push(childSnap.val());
        });

        groupsArrayList = tempGroups;
      }

      //! BUILD EMAIL -> UID MAP
      const usersMap = usersSnap.val() || {};
      const emailToUidMap = {};

      Object.keys(usersMap).forEach((uid) => {
        const email = usersMap[uid];
        if (email) {
          emailToUidMap[email] = uid;
        }
      });

      //! BUILD FRIEND MEMBER LIST (NO EXTRA FIREBASE QUERIES)
      const tempArray = this.snapshotToArray(friendListSnap);
      const memberemaillistArray = [];

      for (let i = 0; i < tempArray.length; i++) {
        const e = tempArray[i];
        const memberUID = emailToUidMap[e.friendEmail];

        if (!memberUID) continue;

        memberemaillistArray.push({
          memberEmail: e.friendEmail,
          memberName: e.friendName,
          memberUID: memberUID,
          memberDisplay: e.friendName + " | " + e.friendEmail,
        });
      }

      //! SINGLE STATE UPDATE
      this.setState({
        isAdmin,
        isSuperAdmin,
        superAdminID,
        groupsArrayList,
        memberemaillistArray,
        loading: false,
      });
    } catch (error) {
      console.error("componentDidMount error:", error);
      this.setState({
        loading: false,
      });
    }
  }

  componentWillUnmount() {
    if (this.languageRef) {
      this.languageRef.off();
    }
  }

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      // customLog(item)
      // customLog(item.key)

      returnArr.push(item);
    });
    // customLog(returnArr)
    return returnArr;
  };

  showNotification(msg, lvl, position, duration) {
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: position,
      autoDismiss: duration,
    });
  }

  createCustomInsertButton() {
    return (
      <button
        className="createGroupBtn"
        onClick={this.handleCreateGroupPopupOpen}
      >
        <i className="fa fa-plus" /> {localizationStrings.createGroupBtn}
      </button>
    );
  }

  createCustomDeleteButton = (onBtnClick) => {
    return (
      <button className="deleteGroupBtn" onClick={onBtnClick}>
        <i className="far fa-trash-alt" /> {localizationStrings.deleteGroupBtn}
      </button>
    );
  };

  async onAfterDeleteRow(rowKeys) {
    // console.log(rowKeys);
    this.showNotification(
      localizationStrings.successfulGrpDelNotif,
      "success",
      "tc",
      5,
    );
    for (let i = 0; i < rowKeys.length; i++) {
      await fire
        .database()
        .ref("GroupManagement")
        .child(this.state.superAdminID)
        .child(auth.currentUser.uid)
        .child(rowKeys[i])
        .child("groupMembers")
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            snapshot.forEach((eachGroupMember) => {
              const eachGroupMemberDetails = eachGroupMember.val();
              if (eachGroupMemberDetails.memberStatus === "member") {
                fire
                  .database()
                  .ref("groupAccounts")
                  .child(this.state.superAdminID)
                  .child("userGroups")
                  .child(eachGroupMemberDetails.memberUID)
                  .child("groups")
                  .child(rowKeys[i])
                  .remove();
              } else {
                this.Disable();
              }
            });
          }
        });

      await fire
        .database()
        .ref("GroupManagement")
        .child(this.state.superAdminID)
        .child(auth.currentUser.uid)
        .child(rowKeys[i])
        .remove();

      await fire
        .database()
        .ref("retractableSharingRegistry")
        .child(auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            snapshot.forEach((eachSharingRegistry) => {
              const eachSharingRegistryDetails = eachSharingRegistry.val();
              if (eachSharingRegistryDetails.sharedToUID === rowKeys[i]) {
                fire
                  .database()
                  .ref("retractableSharingRegistry")
                  .child(auth.currentUser.uid)
                  .child(eachSharingRegistry.key)
                  .remove();
              }
            });
          }
        });
    }

    await this.retrieveGroupDetails();
    // this.showNotification(localizationStrings.successfulGrpDelNotif, "success", "tc", 5);
  }

  createCustomSearchField() {
    return (
      <SearchField
        style={{ marginBottom: "7px" }}
        className="searchBar"
        // id="retractSearch"
        placeholder={localizationStrings.searchPlaceholder}
      />
    );
  }

  createCustomSearchFieldForm() {
    return (
      <SearchField
        // style={{ color: "blue" }}
        className="formSearchBar"
        // id="retractSearch"
        placeholder={localizationStrings.searchPlaceholder}
      />
    );
  }
  isAGroupSharedMode(shareMode) {
    if (
      shareMode != null &&
      //shareMode.includes("RECURR-GRP")
      (shareMode === "NORMAL-RECURR-GRP" ||
        shareMode === "NORMAL-RECURR-TIMED-GRP")
    ) {
      if (shareMode === "NORMAL-RECURR-GRP") {
        return localizationStrings.recurringNonSharedLockTitle;
      } else if (shareMode === "NORMAL-RECURR-TIMED-GRP") {
        return localizationStrings.recurringNonSharedLockTitle;
      }
    } else {
      if (shareMode === "" || shareMode === "NORMAL-GRP" || shareMode == null) {
        return localizationStrings.nonSharedLockTitle;
      } else if (shareMode === "MULTI-GRP") {
        return localizationStrings.multiApproveAccess;
      } else if (shareMode === "MULTI-OTA-GRP") {
        return localizationStrings.multiApproveOneTimeAccess;
      } else if (shareMode === "OTA-GRP") {
        return localizationStrings.oneTimeAccess;
      }
    }
  }
  createCustomExportCSVButton = (onClick) => {
    return (
      <ExportCSVButton
        btnText={localizationStrings.exportCSVTitle}
        className="exportCSVBtn"
        onClick={
          () => this.handleExportCSVButtonClick(onClick)
          // this.testcsv(onclick)
        }
        style={{ marginBottom: 10 }}
      />
    );
  };
  handleExportCSVButtonClick = (onClick) => {
    this.setState({
      showExportPopup: true,
      //showLowBatteryPopup: true
      // showPopup:true
    });
  };

  async handleExportCSV() {
    const { groupsArrayList, selectedGroupRows, isExportingCSV } = this.state;

    if (isExportingCSV) return;

    const groupsToExport =
      selectedGroupRows && selectedGroupRows.length > 0
        ? groupsArrayList.filter((grp) =>
            selectedGroupRows.includes(grp.groupID),
          )
        : groupsArrayList;

    this.setState({ isExportingCSV: true });

    try {
      const wb = XLSX.utils.book_new();

      for (let i = 0; i < groupsToExport.length; i++) {
        const grp = groupsToExport[i];
        const data = [];

        const memberNames = ["MEMBERS:"];

        for (let key in grp.groupMembers) {
          if (grp.groupMembers.hasOwnProperty(key)) {
            const member = grp.groupMembers[key];
            memberNames.push(member.memberEmail);
          }
        }

        const { mergedRows } = await getMergedGroupLocks(grp);

        mergedRows.forEach((lock) => {
          const starttime =
            lock.startDate === 0 || lock.startDate === ""
              ? "∞"
              : this.convertStartTime(lock.startDate);

          const endtime =
            lock.endDate === 0 || lock.endDate === ""
              ? "∞"
              : this.convertEndTime(lock.endDate);

          data.push({
            [localizationStrings.locknameHeader]: lock.lockName || "-",
            [localizationStrings.lockSerialHeader]: lock.lockSerial || "-",
            [localizationStrings.shareModeHeader]: this.isAGroupSharedMode(
              lock.shareMode,
            ),
            [localizationStrings.startHeader]: starttime,
            [localizationStrings.endHeader]: endtime,
          });
        });

        const headerRow = [
          localizationStrings.locknameHeader,
          localizationStrings.lockSerialHeader,
          localizationStrings.shareModeHeader,
          localizationStrings.startHeader,
          localizationStrings.endHeader,
        ];

        const safeSheetName = (grp.groupName || `Group_${i + 1}`)
          .replace(/[\\\/\?\*\[\]]/g, "_")
          .substring(0, 31);

        const ws = XLSX.utils.aoa_to_sheet([memberNames]);

        XLSX.utils.sheet_add_aoa(ws, [[]], { origin: "A2" });
        XLSX.utils.sheet_add_aoa(ws, [headerRow], { origin: "A3" });
        XLSX.utils.sheet_add_json(ws, data, {
          origin: "A4",
          skipHeader: true,
        });

        const colWidths = [
          memberNames,
          [],
          headerRow,
          ...data.map((row) => Object.values(row)),
        ].reduce((widths, row) => {
          row.forEach((val, j) => {
            const value = val ? val.toString() : "";
            widths[j] = Math.max(widths[j] || 10, value.length + 2);
          });
          return widths;
        }, []);

        ws["!cols"] = colWidths.map((w) => ({ wch: w }));

        XLSX.utils.book_append_sheet(wb, ws, safeSheetName);
      }

      const filename = `${auth.currentUser.email}groups.xlsx`;
      XLSX.writeFile(wb, filename);

      this.setState({
        showExportPopup: false,
      });
    } catch (error) {
      console.error("handleExportCSV error:", error);

      if (this.state._notificationSystem) {
        this.state._notificationSystem.addNotification({
          title: <span data-notify="icon" className="pe-7s-attention"></span>,
          message: <div>Failed to export group locks.</div>,
          level: "error",
          position: "tr",
          autoDismiss: 5,
        });
      }
    } finally {
      this.setState({ isExportingCSV: false });
    }
  }

  // async handleExportCSV() {
  //   const { groupsArrayList } = this.state;

  //   const wb = XLSX.utils.book_new();

  //   for (let i = 0; i < groupsArrayList.length; i++) {
  //     const grp = groupsArrayList[i];
  //     const data = [];

  //     let memberNames = ["MEMBERS:"];

  //     for (let key in grp.groupMembers) {
  //       if (grp.groupMembers.hasOwnProperty(key)) {
  //         const member = grp.groupMembers[key];
  //         memberNames.push(member.memberEmail);
  //       }
  //     }

  //     for (let lockKey in grp.groupLocks) {
  //       if (grp.groupLocks.hasOwnProperty(lockKey)) {
  //         const lock = grp.groupLocks[lockKey];
  //         let starttime = "-";
  //         let endtime = "-";
  //         if (lock.shareStartTime > 0 && lock.shareEndTime > 0) {
  //           starttime = this.convertStartTime(lock.shareStartTime);
  //           endtime = this.convertEndTime(lock.shareEndTime);
  //         }

  //         data.push({
  //           [localizationStrings.locknameHeader]: lock.Name,
  //           [localizationStrings.lockSerialHeader]: lock.ip45SerialNumber,
  //           [localizationStrings.shareModeHeader]: this.isAGroupSharedMode(
  //             lock.sharingMode,
  //           ),
  //           [localizationStrings.startHeader]: starttime,
  //           [localizationStrings.endHeader]: endtime,
  //         });
  //       }
  //     }

  //     const headerRow = [
  //       localizationStrings.locknameHeader,
  //       localizationStrings.lockSerialHeader,
  //       localizationStrings.shareModeHeader,
  //       localizationStrings.startHeader,
  //       localizationStrings.endHeader,
  //     ];

  //     const ws = XLSX.utils.aoa_to_sheet([memberNames]);

  //     XLSX.utils.sheet_add_aoa(ws, [[]], { origin: "A2" });

  //     XLSX.utils.sheet_add_aoa(ws, [headerRow], { origin: "A3" });

  //     XLSX.utils.sheet_add_json(ws, data, { origin: "A4", skipHeader: true });

  //     const colWidths = [
  //       memberNames,
  //       [],
  //       headerRow,
  //       ...data.map((row) => Object.values(row)),
  //     ].reduce((widths, row) => {
  //       row.forEach((val, i) => {
  //         const value = val ? val.toString() : "";
  //         widths[i] = Math.max(widths[i] || 10, value.length + 2);
  //       });
  //       return widths;
  //     }, []);

  //     ws["!cols"] = colWidths.map((w) => ({ wch: w }));

  //     XLSX.utils.book_append_sheet(wb, ws, grp.groupName);
  //   }

  //   const filename = `${auth.currentUser.email}groups.xlsx`;
  //   XLSX.writeFile(wb, filename);

  //   this.setState({
  //     showExportPopup: false,
  //   });
  // }

  convertStartTime(startTime) {
    if (localizationStrings.getLanguage() === "ja") {
      var japanDate =
        new Intl.DateTimeFormat("ja-JP", {
          year: "numeric",
        }).format(startTime * 1000) +
        new Intl.DateTimeFormat("ja-JP", {
          month: "numeric",
        }).format(startTime * 1000) +
        new Intl.DateTimeFormat("ja-JP", {
          day: "numeric",
        }).format(startTime * 1000);
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hourCycle: "h12",
        hour: "numeric",
        minute: "2-digit",
      }).format(startTime * 1000);

      return japanDate + " " + japanTime;
    } else {
      const start = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        // second: "2-digit"
      }).format(startTime * 1000);

      return start;
    }
  }
  convertEndTime(endTime) {
    if (localizationStrings.getLanguage() === "ja") {
      var japanDate =
        new Intl.DateTimeFormat("ja-JP", {
          year: "numeric",
        }).format(endTime * 1000) +
        new Intl.DateTimeFormat("ja-JP", {
          month: "numeric",
        }).format(endTime * 1000) +
        new Intl.DateTimeFormat("ja-JP", {
          day: "numeric",
        }).format(endTime * 1000);
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hourCycle: "h12",
        hour: "numeric",
        minute: "2-digit",
      }).format(endTime * 1000);

      return japanDate + " " + japanTime;
    } else {
      const end = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        // second: "2-digit"
      }).format(endTime * 1000);

      return end;
    }
  }
  async retrieveGroupDetails() {
    if (this.state.superAdminID !== "") {
      await fire
        .database()
        .ref("GroupManagement")
        .child(this.state.superAdminID)
        .child(auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          var tempArray = [];
          snapshot.forEach(function(childSnap) {
            tempArray.push(childSnap.val());
          });

          this.setState({
            groupsArrayList: tempArray,
            loading: false,
          });
        });
    }

    return this.state.groupsArrayList;
  }

  retrieveChanges = (data) => {
    this.setState({
      groupsArrayList: data,
      loading: false,
    });
  };

  handleCreateGroupPopupOpen() {
    this.setState({
      showPopup: true,
    });
  }

  handleCreateGroupPopupClose = (callback) => {
    this.setState(
      {
        showPopup: false,
        groupName: "",
        groupNameExist: false,
        groupDesc: "",
        selectedMember: [],
        selectedMemberValue: [],
      },
      () => {
        if (typeof callback === "function") {
          callback();
        }

        setTimeout(() => {
          this.loadMemberEmailList();
        }, 0);
      },
    );
  };

  loadMemberEmailList = async () => {
    try {
      const snapshot = await fire
        .database()
        .ref("userFriendListIndustrial")
        .child(auth.currentUser.uid)
        .once("value");

      const tempArray = this.snapshotToArray(snapshot);

      const members = await Promise.all(
        tempArray.map(async (e) => {
          const snap = await fire
            .database()
            .ref("registeredUsersOnPlatform")
            .orderByValue()
            .equalTo(e.friendEmail)
            .once("value");

          if (!snap.exists()) return null;

          const memberUID = Object.keys(snap.val())[0];

          return {
            memberEmail: e.friendEmail,
            memberName: e.friendName,
            memberUID,
            memberDisplay: `${e.friendName} | ${e.friendEmail}`,
          };
        }),
      );

      this.setState({
        memberemaillistArray: members.filter(Boolean),
      });
    } catch (error) {
      console.error("loadMemberEmailList error:", error);
    }
  };

  onSubmit = () => {
    const {
      groupName,
      selectedMember,
      superAdminID,
      addGroupLoading,
    } = this.state;

    if (addGroupLoading) return;

    const hasGroupName = groupName.trim() !== "";
    const hasEnoughMembers = selectedMember.length > 1;

    if (hasGroupName && hasEnoughMembers) {
      this.setState(
        {
          addGroupLoading: true,
          groupNameExist: false,
        },
        () => {
          this.insertGroupData(superAdminID);
        },
      );
      return;
    }

    let message = localizationStrings.createGrpUnsuccessfulNotif;

    if (!hasGroupName && !hasEnoughMembers) {
      message = localizationStrings.selectMemberEnterNameNotif;
    } else if (!hasGroupName) {
      message = localizationStrings.enterNameNotif;
    } else if (!hasEnoughMembers) {
      message = localizationStrings.selectMemberNotif;
    }

    this.showNotification(message, "error", "tc", 5);

    this.setState({
      addGroupLoading: false,
    });
  };

  insertGroupData = async (superAdminID) => {
    try {
      const currentUID = auth.currentUser.uid;
      const currentEmail = auth.currentUser.email;
      const { groupName, groupDesc, selectedMember } = this.state;

      const trimmedGroupName = groupName.trim();
      const normalizedGroupName = trimmedGroupName.toLowerCase();

      const groupManagementRef = fire
        .database()
        .ref("GroupManagement")
        .child(superAdminID)
        .child(currentUID);

      const snapshot = await groupManagementRef.once("value");

      let groupNameExist = false;

      if (snapshot.exists()) {
        snapshot.forEach((group) => {
          const existingName = (group.val().groupName || "")
            .trim()
            .toLowerCase();

          if (existingName === normalizedGroupName) {
            groupNameExist = true;
            return true;
          }
          return false;
        });
      }

      if (groupNameExist) {
        this.setState(
          {
            groupNameExist: true,
            addGroupLoading: false,
          },
          () => {
            this.showNotification(
              localizationStrings.grpNameExistNotif,
              "error",
              "tc",
              5,
            );
          },
        );
        return;
      }

      const groupID = groupManagementRef.push().key;
      const updates = {};
      const groupMembersWithUID = {};

      for (let i = 0; i < selectedMember.length; i++) {
        const eachGroupMember = selectedMember[i];
        const memberUID = eachGroupMember.memberUID;

        groupMembersWithUID[memberUID] = {
          memberEmail: eachGroupMember.memberEmail,
          memberName: eachGroupMember.memberName,
          memberUID: memberUID,
          memberStatus: "member",
        };

        updates[
          `groupAccounts/${superAdminID}/userGroups/${memberUID}/memberEmail`
        ] = eachGroupMember.memberEmail;

        updates[
          `groupAccounts/${superAdminID}/userGroups/${memberUID}/groups/${groupID}`
        ] = {
          groupAdminEmail: currentEmail,
          groupAdminUID: currentUID,
          groupID: groupID,
        };
      }

      updates[`GroupManagement/${superAdminID}/${currentUID}/${groupID}`] = {
        groupName: trimmedGroupName,
        groupDesc,
        groupID,
        groupMembers: groupMembersWithUID,
        timeCreated: Date.now(),
      };

      await fire
        .database()
        .ref()
        .update(updates);

      await this.retrieveGroupDetails();

      this.setState(
        {
          addGroupLoading: false,
          groupNameExist: false,
        },
        () => {
          this.handleCreateGroupPopupClose(() => {
            this.showNotification(
              localizationStrings.grpCreatedNotif,
              "success",
              "tc",
              5,
            );
          });
        },
      );
    } catch (error) {
      console.error("insertGroupData error:", error);

      this.setState(
        {
          addGroupLoading: false,
        },
        () => {
          this.showNotification(
            localizationStrings.createGrpUnsuccessfulNotif,
            "error",
            "tc",
            5,
          );
        },
      );
    }
  };

  handleGroupNameChange(e) {
    this.setState({
      groupName: e.target.value,
    });
  }

  handleGroupDescChange(e) {
    this.setState({
      groupDesc: e.target.value,
    });
  }

  handleSelectedMembers(selectedMembers) {
    var memberemailarray = [];
    _.map(selectedMembers, (memberData) => {
      memberemailarray.push(memberData.memberEmail);
    });
    this.setState({
      selectedMember: selectedMembers,
      selectedMemberValue: memberemailarray,
    });
  }

  createGroupCustomDeleteButton = (onBtnClick) => {
    return (
      <Button id="deleteMemberBtn" onClick={onBtnClick}>
        <i className="far fa-trash-alt" /> {localizationStrings.removeMemberBtn}
      </Button>
    );
  };

  customConfirmDialog(next) {
    next();
  }

  createGroupOnAfterDeleteRow(emailDeleted) {
    var memberemailarray;
    var selectedMembers;

    memberemailarray = this.state.selectedMemberValue.filter(
      (value) => !emailDeleted.includes(value),
    );
    selectedMembers = this.state.selectedMember.filter(
      (value) => !emailDeleted.includes(value.memberEmail),
    );

    this.setState({
      selectedMember: selectedMembers,
      selectedMemberValue: memberemailarray,
    });
  }

  convertTimeStamp(createdTime) {
    if (localizationStrings.getLanguage() === "ja") {
      // var japanDate = new Intl.DateTimeFormat("ja-JP", { era: "long" }).format(
      //   createdTime
      // );
      // var japanTime = new Intl.DateTimeFormat("ja-JP", {
      //   hour: "2-digit",
      //   minute: "2-digit"
      // }).format(createdTime);
      // return japanDate + japanTime;
      var japanDate =
        new Intl.DateTimeFormat("ja-JP", {
          year: "numeric",
        }).format(createdTime) +
        new Intl.DateTimeFormat("ja-JP", {
          month: "numeric",
        }).format(createdTime) +
        new Intl.DateTimeFormat("ja-JP", {
          day: "numeric",
        }).format(createdTime);
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hourCycle: "h12",
        hour: "numeric",
        minute: "2-digit",
      }).format(createdTime);
      return japanDate + " " + japanTime;
    } else {
      // return new Intl.DateTimeFormat("en-US", {
      //   year: "numeric",
      //   month: "long",
      //   day: "numeric",
      //   hour: "numeric",
      //   minute: "2-digit"
      //   // second: "2-digit"
      // }).format(createdTime);
      return <TimeStamp time={createdTime / 1000} format="full" />;
    }
  }

  renderGroupProfile(cell, row) {
    return <GroupProfile cellValue={cell} rowValue={row} />;
  }

  renderLockDetailsBtn(cell, row) {
    return <LockDetailsButton cellValue={cell} rowValue={row} />;
  }

  renderGroupDetailsBtn(cell, row) {
    // console.log(row);
    return (
      <GroupDetailsButton
        cellValue={cell}
        rowValue={row}
        dataCallBack={this.retrieveChanges}
      />
    );
  }

  onToggleDropDown = (toggleDropDown) => {
    // do your stuff here
    // console.log(toggleDropDown)
    // console.log("toggle dropdown");
    toggleDropDown();
  };

  renderSizePerPageDropDown = (props) => {
    return (
      <SizePerPageDropDown
        // className='my-size-per-page'
        // btnContextual='btn-warning'
        variation="dropup"
        onClick={() => this.onToggleDropDown(props.toggleDropDown)}
        {...props}
      />
    );
  };

  renderSelectMember(cell, row) {
    return (
      <div>
        <button
          className={"select-btn"}
          onClick={(e) => {
            e.preventDefault();

            const allMembersArrayList = this.state.memberemaillistArray;
            const selectedMembersArrayList = this.state.selectedMember;

            selectedMembersArrayList.push(row);
            allMembersArrayList.splice(allMembersArrayList.indexOf(row), 1);

            this.setState({
              memberemaillistArray: allMembersArrayList,
              selectedMember: selectedMembersArrayList,
            });
          }}
        >
          <span className="plusIcon">&#43;</span>
        </button>
      </div>
    );
  }

  Disable() {
    return <button disabled={true}>I am Admin!</button>;
  }
  unselectMember(cell, row) {
    return (
      <div>
        <button
          className={"unselect-btn"}
          onClick={(e) => {
            e.preventDefault();

            const allMembersArrayList = this.state.memberemaillistArray;
            const selectedMembersArrayList = this.state.selectedMember;

            allMembersArrayList.push(row);
            selectedMembersArrayList.splice(
              selectedMembersArrayList.indexOf(row),
              1,
            );

            this.setState({
              memberemaillistArray: allMembersArrayList,
              selectedMember: selectedMembersArrayList,
            });
          }}
        >
          <span className="crossIcon">&times;</span>
        </button>
      </div>
    );
  }

  handlePopupOpen() {
    this.setState({
      showPopupHelp: true,
      popupTitle: localizationStrings.createGroupGuide,
      popupImage: [<CreateGroupGuide />],
      showExportPopup: true,
    });
  }

  handlePopupClose() {
    this.setState({
      showPopupHelp: false,
      showExportPopup: false,
      selectedGroups: [],
    });
  }

  loadingData() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <NoDataFound />
        </div>
      );
    }
  }

  handleGroupRowSelect = (row, isSelected) => {
    const { selectedGroupRows } = this.state;

    const updatedSelectedRows = isSelected
      ? [...selectedGroupRows, row.groupID]
      : selectedGroupRows.filter((groupID) => groupID !== row.groupID);

    this.setState({ selectedGroupRows: updatedSelectedRows });
  };

  handleSelectAllGroup = (isSelected) => {
    const { groupsArrayList } = this.state;

    const updatedSelectedRows = isSelected
      ? groupsArrayList.map((row) => row.groupID)
      : [];

    this.setState({ selectedGroupRows: updatedSelectedRows });
  };

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const customTotal = (from, to, size) => (
      <span
        className="react-bootstrap-table-pagination-total"
        style={{ float: "right" }}
      >
        {localizationStrings.resultTitle1}
        {from}
        {localizationStrings.resultTitle2}
        {to}
        {localizationStrings.resultTitle3}
        {size}
        {localizationStrings.resultTitle4}
      </span>
    );

    const options = {
      insertBtn: this.createCustomInsertButton,
      deleteBtn: this.createCustomDeleteButton,
      searchField: this.createCustomSearchField,
      handleConfirmDeleteRow: (next, rowKeys) =>
        confirmRemove(next, rowKeys, this.state.groupsArrayList),
      afterDeleteRow: this.onAfterDeleteRow,
      // sizePerPageDropDown: this.renderSizePerPageDropDown,
      page: 1, // which page you want to show as default
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "100",
          value: 100,
        },
        {
          text: "All",
          value: this.state.groupsArrayList.length,
        },
      ], // you can change the dropdown list for size per page
      sizePerPage: 10, // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 3, // the pagination bar size.
      prePage: "<", // Previous page button text
      nextPage: ">", // Next page button text
      firstPage: "<<", // First page button text
      lastPage: ">>", // Last page button text
      paginationShowsTotal: customTotal,
      noDataText: this.loadingData(),
      exportCSVBtn: this.createCustomExportCSVButton,
    };

    const columnHover = (cell, row, enumObject, rowIndex) => {
      return cell;
    };

    const exportGroupsList =
      this.state.selectedGroupRows && this.state.selectedGroupRows.length > 0
        ? this.state.groupsArrayList.filter((grp) =>
            this.state.selectedGroupRows.includes(grp.groupID),
          )
        : this.state.groupsArrayList;

    return (
      <div className="header" style={{ maxWidth: "95%", margin: "auto" }}>
        <NotificationSystem ref="notificationSystem" style={style} />

        {/* <h2>Group Management</h2> */}
        <h4 style={{ marginTop: "30px", marginBottom: "20px" }}>
          {localizationStrings.descriptionTitle}
        </h4>

        {/* <button className="helpBtn" onClick={this.handlePopupOpen}>
          <p className="fa fa-question-circle" />
          <p style={{ fontSize: "24px" }}>Help</p>
        </button> */}
        {/* <h6 className="instructionStyle">Double Click name to edit</h6> */}
        {/* <br /> */}
        <br />
        <BootstrapTable
          // data={this.retrieveGroupDetails()}
          data={this.state.groupsArrayList}
          bordered={false}
          pagination
          exportCSV
          options={options}
          selectRow={{
            mode: "checkbox",
            // clickToSelect: true,
            selected: this.state.selectedGroupRows,
            onSelect: this.handleGroupRowSelect,
            onSelectAll: this.handleSelectAllGroup,
          }}
          insertRow
          deleteRow
          search
        >
          <TableHeaderColumn
            dataField="groupID"
            isKey={true}
            hidden
          ></TableHeaderColumn>
          {/* <TableHeaderColumn dataField="groupName">
            Group Name
          </TableHeaderColumn> */}
          <TableHeaderColumn
            dataField="groupName"
            columnTitle={columnHover}
            // dataFormat={this.renderGroupProfile}
            dataSort
          >
            {localizationStrings.groupNameHeader}
          </TableHeaderColumn>
          <TableHeaderColumn width="30%" dataFormat={this.renderLockDetailsBtn}>
            {localizationStrings.groupLocksHeader}
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="timeCreated"
            dataFormat={this.convertTimeStamp}
            // columnTitle={this.convertTimeStamp}
            dataSort
            tdStyle={{
              paddingLeft: "3%",
              whiteSpace: "normal",
            }}
            thStyle={{
              paddingLeft: "3%",
            }}
          >
            {localizationStrings.createdAtHeader}
          </TableHeaderColumn>
          <TableHeaderColumn
            width="13%"
            // dataField="groupName"
            dataFormat={this.renderGroupProfile}
            // dataSort
            tdStyle={{ textAlign: "center" }}
            thStyle={{ textAlign: "center" }}
          >
            {localizationStrings.groupInfoHeader}
          </TableHeaderColumn>
          <TableHeaderColumn
            width="13%"
            dataFormat={this.renderGroupDetailsBtn}
            tdStyle={{ textAlign: "center" }}
            thStyle={{ textAlign: "center" }}
          >
            {localizationStrings.groupEditHeader}
          </TableHeaderColumn>
        </BootstrapTable>

        {/* //! Popup for Create Group Button */}
        <Modal
          show={this.state.showPopup}
          onHide={this.handleCreateGroupPopupClose}
          dialogClassName="modal-70w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.createGroupBtn}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "30px 30px 40px 30px" }}>
            <form>
              <FormGroup>
                <ControlLabel style={{ fontSize: "1.2em" }}>
                  {localizationStrings.groupNameHeader}
                </ControlLabel>
                <FormControl
                  type="text"
                  placeholder={localizationStrings.groupNamePlaceholder}
                  onChange={this.handleGroupNameChange}
                ></FormControl>
              </FormGroup>
              <br />
              <FormGroup>
                <ControlLabel style={{ fontSize: "1.2em" }}>
                  {localizationStrings.groupDescriptionHeader}
                </ControlLabel>
                <FormControl
                  style={{ height: "100px" }}
                  componentClass="textarea"
                  placeholder={localizationStrings.groupDescriptionPlaceholder}
                  onChange={this.handleGroupDescChange}
                />
              </FormGroup>
              <br />
              <ControlLabel style={{ fontSize: "1.2em" }}>
                {localizationStrings.addMembersHeader}
              </ControlLabel>
              {/* <Multiselect
                style={{ fontSize: "1.15em" }}
                data={this.state.memberemaillistArray}
                valueField="memberEmail"
                textField="memberDisplay"
                onChange={this.handleSelectedMembers}
                value={this.state.selectedMemberValue}
                placeholder="-Select Members-"
              ></Multiselect> */}

              {/* <br /> */}
              {/* <br /> */}
              {/* <BootstrapTable
                data={this.state.selectedMember}
                bordered={true}
                pagination
                options={{
                  sizePerPage: 5,
                  hideSizePerPage: true,
                  deleteBtn: this.createGroupCustomDeleteButton,
                  handleConfirmDeleteRow: this.customConfirmDialog,
                  afterDeleteRow: this.createGroupOnAfterDeleteRow
                  // noDataText: localizationStrings.noDataTitle
                }}
                selectRow={{ mode: "checkbox" }}
                deleteRow
              >
                <TableHeaderColumn
                  dataField="memberName"
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  Name
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="memberEmail"
                  isKey={true}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  Email
                </TableHeaderColumn>
              </BootstrapTable> */}
              <div className="selectMembersTable">
                <BootstrapTable
                  data={this.state.memberemaillistArray}
                  bordered={false}
                  pagination
                  options={{
                    sizePerPage: 5,
                    hideSizePerPage: true,
                    searchField: this.createCustomSearchFieldForm,
                    defaultSortName: "memberName", // default sort column name
                    defaultSortOrder: "asc", // default sort order
                    noDataText: localizationStrings.noDataTitle,
                    // deleteBtn: this.createGroupCustomDeleteButton,
                    // handleConfirmDeleteRow: this.customConfirmDialog,
                    // afterDeleteRow: this.createGroupOnAfterDeleteRow
                    // noDataText: localizationStrings.noDataTitle
                  }}
                  search
                >
                  <TableHeaderColumn
                    // dataSort
                    dataField="memberName"
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.nameHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="memberEmail"
                    isKey={true}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    // dataField="memberEmail"
                    dataFormat={this.renderSelectMember}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  ></TableHeaderColumn>
                </BootstrapTable>
                <ControlLabel style={{ fontSize: "1.2em" }}>
                  {localizationStrings.selectedMembersHeader}
                </ControlLabel>
                <BootstrapTable
                  data={this.state.selectedMember}
                  bordered={false}
                  pagination
                  options={{
                    sizePerPage: 5,
                    hideSizePerPage: true,
                    noDataText: localizationStrings.noDataTitle,
                    searchField: this.createCustomSearchFieldForm,
                    defaultSortName: "memberName", // default sort column name
                    defaultSortOrder: "asc", // default sort order
                    // defaultSortName: "memberName", // default sort column name
                    // defaultSortOrder: "asc" // default sort order
                    // deleteBtn: this.createGroupCustomDeleteButton,
                    // handleConfirmDeleteRow: this.customConfirmDialog,
                    // afterDeleteRow: this.createGroupOnAfterDeleteRow
                    // noDataText: localizationStrings.noDataTitle
                  }}
                  search
                  // selectRow={{ mode: "checkbox" }}
                  // deleteRow
                >
                  <TableHeaderColumn
                    // dataSort
                    dataField="memberName"
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.nameHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="memberEmail"
                    isKey={true}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    // dataField="memberEmail"
                    dataFormat={this.unselectMember}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  ></TableHeaderColumn>
                </BootstrapTable>
              </div>
              {/* <br /> */}
              <FormGroup style={{ display: "flex" }}>
                <Button
                  style={{ marginRight: "10px" }}
                  onClick={this.onSubmit}
                  disabled={this.state.addGroupLoading}
                >
                  {this.state.addGroupLoading
                    ? localizationStrings.loading
                    : localizationStrings.createTitle}
                </Button>
                <Button
                  style={{ marginLeft: "10px" }}
                  onClick={this.handleCreateGroupPopupClose}
                >
                  {localizationStrings.cancelTitle}
                </Button>
              </FormGroup>
            </form>
          </Modal.Body>
        </Modal>
        {/* //! Popup for Help Button */}
        <Modal
          show={this.state.showPopupHelp}
          onHide={this.handlePopupClose}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.popupTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{this.state.popupImage}</Modal.Body>
        </Modal>
        <Modal
          show={this.state.showExportPopup}
          onHide={() => {
            if (!this.state.isExportingCSV) {
              this.handlePopupClose();
            }
          }}
          backdrop={this.state.isExportingCSV ? "static" : true}
          keyboard={!this.state.isExportingCSV}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton={!this.state.isExportingCSV}>
            <Modal.Title>{localizationStrings.exportGroupsHeader}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <BootstrapTable data={exportGroupsList} bordered={false} pagination>
              <TableHeaderColumn
                dataField="groupID"
                isKey={true}
                hidden
              ></TableHeaderColumn>
              <TableHeaderColumn
                dataField="groupName"
                columnTitle={columnHover}
                dataSort
              >
                {localizationStrings.groupNameHeader}
              </TableHeaderColumn>
              <TableHeaderColumn
                width="30%"
                dataFormat={this.renderLockDetailsBtn}
              >
                {localizationStrings.groupLocksHeader}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="timeCreated"
                dataFormat={this.convertTimeStamp}
                dataSort
                tdStyle={{
                  paddingLeft: "3%",
                  whiteSpace: "normal",
                }}
                thStyle={{
                  paddingLeft: "3%",
                }}
              >
                {localizationStrings.createdAtHeader}
              </TableHeaderColumn>
              <TableHeaderColumn
                width="13%"
                dataFormat={this.renderGroupProfile}
                tdStyle={{ textAlign: "center" }}
                thStyle={{ textAlign: "center" }}
              >
                {localizationStrings.groupInfoHeader}
              </TableHeaderColumn>
            </BootstrapTable>

            <div
              className="exportCSVpopupButtons"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "10px",
                marginTop: "15px",
              }}
            >
              <Button
                onClick={this.handleExportCSV}
                className="btn btn-info"
                style={{
                  borderRadius: "50px",
                  width: "auto",
                  minWidth: "120px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                disabled={this.state.isExportingCSV}
              >
                {this.state.isExportingCSV ? (
                  <>
                    <i
                      className="fa fa-spinner fa-spin"
                      style={{ marginRight: 8 }}
                    />
                    Exporting...
                  </>
                ) : (
                  localizationStrings.exportBtn
                )}
              </Button>

              <button
                className="cancelButton"
                onClick={this.handlePopupClose}
                disabled={this.state.isExportingCSV}
                style={{
                  width: "auto",
                  minWidth: "120px",
                }}
              >
                {localizationStrings.cancelBtn}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(GroupManagement);
